<section class="content">
  <div class="card" style="padding: 25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Select Date</mat-label>
        <input type="date" [(ngModel)]="selected_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label style="color: firebrick;">Select Shift</mat-label>
        <mat-select [(ngModel)]="session_id" class="main-border-class">
          <mat-option value="1">Morning</mat-option>
          <mat-option value="2">Evening</mat-option>
        </mat-select>
      </div>
      <div class="col-3" *ngIf="session_id !== null">
        <mat-label style="color: firebrick;">Select Route</mat-label>
        <mat-select [(ngModel)]="route_id" class="main-border-class" *ngIf="session_id == 1">
          <mat-option [value]="route.id" *ngFor="let route of mor_route_list">{{route['name']}}</mat-option>
        </mat-select>
        <mat-select [(ngModel)]="route_id" class="main-border-class" *ngIf="session_id == 2">
          <mat-option [value]="route.id" *ngFor="let route of eve_route_list">{{route['name']}}</mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 20%;border-radius: 10px;background: blanchedalmond;"
          [disabled]="selected_date == null || route_id == null">Get</button>
      </div>
    </div>

    <table class="table" *ngIf="mismatch_data !== null">
      <thead>
        <tr>
          <th>S. No</th>
          <th>Booth Code</th>
          <th>Ordered By</th>
          <th>Ordered on</th>
          <th>Edited on</th>
          <th>Ordered Via</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of mismatch_data; let index=index">
          <td>{{ index + 1}}</td>
          <td>{{ data['booth_code']}}</td>
          <td>{{ data['ordered_by']}}</td>
          <td>{{ data['time_created'] | date : 'medium'}}</td>
          <td>{{ data['time_modified'] | date : 'medium'}}</td>
          <td>{{ data['ordered_via_name']}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
